"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var components_lib_1 = require("@dynamynd/components-lib");

var react_1 = __importDefault(require("react"));

var FieldLabels_enum_1 = require("./FieldLabels.enum");

var FieldNames_enum_1 = require("./FieldNames.enum");

exports.Password = function (props) {
  var isSubmitting = props.isSubmitting;
  return react_1.default.createElement(components_lib_1.RowFlexStartResponsive, null, react_1.default.createElement(components_lib_1.FormInput, __assign({
    name: FieldNames_enum_1.FieldNames.currentPassword,
    label: FieldLabels_enum_1.FieldLabels.currentPassword,
    isSecure: true,
    isDisabled: isSubmitting
  }, props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
    name: FieldNames_enum_1.FieldNames.password,
    label: FieldLabels_enum_1.FieldLabels.password,
    isSecure: true,
    isDisabled: isSubmitting
  }, props)), react_1.default.createElement(components_lib_1.FormInput, __assign({
    name: FieldNames_enum_1.FieldNames.confirmPassword,
    label: FieldLabels_enum_1.FieldLabels.confirmPassword,
    isSecure: true,
    isDisabled: isSubmitting
  }, props)));
};